// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1705":"ab79cfd529552e53","2888":"cf4ce34adfcbb823","6632":"ab79cfd529552e53"}[chunkId] + ".css";
};